import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { collection, query, where, getDocs, doc } from "firebase/firestore";
import { db } from "../firebase";
import Home from "./Home";
import Profile from "../components/Profile";
import Newprof from "../components/Newprof";
import PropagateLoader from "react-spinners/HashLoader";
const Doxprofile = () => {
  const params = useParams();
  const { displayName } = params;
  const [user, setUser] = useState(null);
  const [err, setErr] = useState(false);
  const [isLoading, setisLoading] = useState(true);
  const override = `
  display: block;
  `;
  const style = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  };
  useEffect(() => {
    const q = query(
      collection(db, "users"),
      where("displayName", "==", displayName)
    );
    getDocs(q).then((res) => {
      if (res.docs.length === 0) {
        setErr(true);
      }
      res.forEach((doc) => {
        if (doc.data().displayName) {
          setUser(doc.data());
        }
      });
    });
    setisLoading(false);
  }, []);
  return (
    <div className="cont">
      {isLoading && (
        <PropagateLoader
          color={"#4d00ac"}
          isLoading={isLoading}
          css={override}
          size={60}
          style={style}
        />
      )}

      {!isLoading && user && !err && (
        <div className="doxprof">
          <Newprof user={user} />
        </div>
      )}
      {!isLoading && err && (
        <div className="exist">
          <span>User does not exist !</span>
        </div>
      )}
    </div>
  );
};

export default Doxprofile;
